import axios from 'axios';
import QueryString from 'query-string';
export interface ShortLinkResponse {
  shortLink: string;
  previewLink: string;
}

class FirebaseService {
  /**
   * Make a request to the firebase endpoint to get the short link
   *
   * @param longDynamicLink Full url of dynamic link
   * @param key Firebase API key
   * @returns Short url of dynamic link
   */
  static getShortLink = async (
    longDynamicLink: string,
    key: string = process.env.REACT_APP_WEB_FB_API_KEY ?? '',
  ) => {
    try {
      const response = await axios.post<ShortLinkResponse>(
        `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${key}`,
        {
          longDynamicLink,
          suffix: { option: 'SHORT' },
        },
      );
      return response.data.shortLink;
    } catch {
      return longDynamicLink;
    }
  };

  /**
   * Get the full dynamic link from the link with params
   *
   * @param {string} webPath path to the web page
   * @param {string} mobileDeepLink Deep link to the mobile app
   * @param {string} baseUrl Full link to be parsed
   * @param {Object} queryStringParams Query string parameters
   * @param {Object} linkQueryStringParams Query string parameters for link
   * @param {string | undefined} webAppLink path to the web app
   * @returns {string} The full dynamic link URL
   */
  static createDynamicLink = (
    webPath: string,
    mobileDeepLink: string = webPath,
    baseUrl: string = process.env.REACT_APP_DL_LINK ?? 'https://onetouch.astropay.com',
    queryStringParams = {},
    linkQueryStringParams = {},
    webAppLink?: string,
  ) => {
    const queryStringLink = QueryString.stringify(linkQueryStringParams, {
      encode: false,
      sort: false,
    });

    const otherLink = `${baseUrl}${webPath}`;

    //return always weblink for sandbox
    if (process.env.REACT_APP_WEB_BASE_URL?.includes('stg')) {
      return otherLink;
    }
    //web app link
    const webLink = webAppLink
      ? `${webAppLink}${mobileDeepLink}${queryStringLink ? '?' + queryStringLink : ''}`
      : undefined;

    const qsParams: { [k: string]: string | undefined } = {
      link: webLink ?? `${baseUrl}${mobileDeepLink}${queryStringLink ? '?' + queryStringLink : ''}`,
      apn: process.env.REACT_APP_DL_APN,
      ibi: process.env.REACT_APP_DL_IBI,
      afl: otherLink,
      ifl: otherLink,
      ofl: otherLink,
      ...queryStringParams,
    };

    const queryString = QueryString.stringify(qsParams, { encode: false, sort: false });

    return FirebaseService.getShortLink(`${process.env.REACT_APP_DL_URL}?${queryString}`);
  };
}

export default FirebaseService;
